"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Selector = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const react_1 = __importStar(require("react"));
const selector_styles_1 = require("./selector.styles");
require("./selector.types");
const Check = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/rgs-check'))));
const Selector = (_a) => {
    var { error } = _a, props = __rest(_a, ["error"]);
    const theme = (0, theme_1.useTheme)();
    return (react_1.default.createElement(selector_styles_1.SelectorContainer, null,
        react_1.default.createElement(selector_styles_1.SelectorInput, Object.assign({}, props)),
        react_1.default.createElement(selector_styles_1.SelectorContent, { disabled: !!props.disabled, error: !!error },
            react_1.default.createElement(react_1.Suspense, { fallback: null },
                react_1.default.createElement(selector_styles_1.IconContainer, null,
                    react_1.default.createElement(Check, { width: 13, viewBox: "0 0 13 11", color: props.disabled
                            ? theme.colors.neutral[50]
                            : theme.colors['on-accent'].primary }))))));
};
exports.Selector = Selector;
